import { ExternalLink } from "lucide-react";
import { useSeo } from "../lib/seo";
import { BUSINESS } from "../data/content";

export default function Book() {
  useSeo("Book an appointment", "Book an appointment with Deaf Education Consulting LLC. Pick an open time on Michelle's Google booking page, in person or virtual.");
  return (
    <>
      <section className="bg-teal text-paper" data-testid="book-intro">
        <div className="max-w-6xl mx-auto px-6 py-16 md:py-24 grid md:grid-cols-[1.2fr_1fr] gap-10 items-end">
          <div>
            <p className="lbl text-sky fd">Booking</p>
            <h1 className="mt-6"><span className="ln"><span>Book an appointment</span></span></h1>
          </div>
          <div className="fd f1">
            <p className="text-lg">Choose an open time below. You'll get a confirmation email from Google with the details.</p>
            <p className="lbl mt-4 text-sky">Travel season: June, July, August</p>
          </div>
        </div>
      </section>
      <section className="bg-sky text-ink py-12 md:py-20">
        <div className="max-w-6xl mx-auto px-6">
          <div className="bg-paper rounded-2xl overflow-hidden shadow-sm">
            <iframe
              src={BUSINESS.bookingEmbed}
              title="Michelle Andros appointment booking calendar (Google Calendar)"
              className="w-full h-[760px] border-0"
              loading="lazy"
              data-testid="google-booking-iframe"
            />
          </div>
          <p className="mt-6 font-sans text-slate">
            Trouble seeing the calendar?{" "}
            <a href={BUSINESS.bookingUrl} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-teal underline underline-offset-4" data-testid="google-booking-link">
              Open the booking page in a new tab <ExternalLink className="w-4 h-4" aria-hidden="true" />
            </a>{" "}
            or <a href="/contact#consultation" className="text-teal underline underline-offset-4" data-testid="book-consultation-link">request a consultation</a> instead.
          </p>
        </div>
      </section>
    </>
  );
}
